<template>
  <div class="empty-configuration">
    <button v-if="canAdd" class="empty-icon" type="button" @click="$emit('add')">+</button>
    <h4>No configuration available</h4>
    <p>{{ emptyMessage }}</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyConfiguration',
  props: {
    label: {
      type: String,
      required: true
    },
    canAdd: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    emptyMessage () {
      return this.canAdd
        ? `Create the first rule for ${this.label} to define templates, conditions, and actions.`
        : `No rules are configured for ${this.label} yet.`
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-configuration {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 340px;
  max-width: 960px;
  border: 1px dashed #d7dde7;
  border-radius: 8px;
  background: #ffffff;
  text-align: center;

  h4 {
    margin: 12px 0 6px;
    color: #344054;
    font-size: var(--text-xl);
  }

  p {
    max-width: 360px;
    margin: 0 0 18px;
    color: #667085;
    font-size: var(--text-m);
    line-height: 1.5;
  }

}

.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 0;
  border-radius: 50%;
  background: #eef4ff;
  color: #246bfe;
  font-size: var(--text-4xl);
  cursor: pointer;
  transition: background 0.18s ease, transform 0.18s ease;

  &:hover {
    background: #dbeafe;
    transform: translateY(-1px);
  }
}
</style>
